import responsiveSize from 'helper/responsiveSize'
import styled from 'styled-components'
import { Theme } from 'styles/Themes'

export default styled.div`
  width: ${responsiveSize.responsiveWidth(Theme.sizes.BANNER.WIDTH.PRIMARY)};
  height: ${responsiveSize.responsiveHeight(Theme.sizes.BANNER.HEIGHT.PRIMARY)};

  border-radius: 5px;
  background: ${Theme.pallete.SECONDARY};
  box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.25);

  .banner-img {
    width: ${responsiveSize.responsiveWidth(Theme.sizes.BANNER.WIDTH.PRIMARY)};
    height: ${responsiveSize.responsiveHeight(
      Theme.sizes.BANNER.HEIGHT.PRIMARY
    )};
    z-index: 2;
  }

  .banner-title {
    color: ${Theme.pallete.SECONDARY};
    font-family: ${Theme.fontFamily.SECONDARY};
    font-size: ${responsiveSize.responsiveWidth(
      Theme.sizes.BANNER.FONT.PRIMARY
    )};
    font-style: normal;
    font-weight: 700;
    line-height: 140%; /* 19.6px */
    letter-spacing: -0.322px;

    z-index: 1;
  }

  .banner-span {
    color: ${Theme.pallete.SECONDARY};
    font-family: ${Theme.fontFamily.SECONDARY};
    font-size: ${responsiveSize.responsiveWidth(
      Theme.sizes.BANNER.FONT.SECONDARY
    )};
    font-style: normal;
    font-weight: 500;
    line-height: 140%; /* 16.8px */
    letter-spacing: -0.276px;

    z-index: 1;
  }
`
